import {
  AttributeDTO,
  AttributeValueTypeDTO,
} from '@/entities/srm/ci/@x/user-attribute';
import { z } from 'zod/v4';
// UserAttributeModifiersDTO
export const UserAttributeModifiersDTO = z.object({
  required: z.boolean(),
  blocked: z.boolean(),
});
export type UserAttributeModifiers = z.infer<typeof UserAttributeModifiersDTO>;

// UserAttributeDTO extends AttributeDTO with modifiers
export const UserAttributeDTO = AttributeDTO.extend({
  modifiers: UserAttributeModifiersDTO,
  value_type: AttributeValueTypeDTO,
});
export type UserAttribute = z.infer<typeof UserAttributeDTO>;

// UserAttributeCreateDTO is UserAttributeDTO without 'id'
export const UserAttributeCreateDTO = UserAttributeDTO.omit({ id: true });
export type UserAttributeCreate = z.infer<typeof UserAttributeCreateDTO>;